import React from 'react'
import { LoadingSpinner } from './LoadingSpinner'

export const FullPageSpinner: React.FC = () => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <LoadingSpinner size="lg" />
  </div>
)
